<div class="pl-8 display-flex flex-column grid-gap-4" [formGroup]="form">
  <app-radio-button
    formControlName="mobileMode"
    [items]="options"
    [radioGroupClass]="'display-flex flex-column'"
    [optionCss]="'body'"></app-radio-button>
</div>
